<template>
  <div>
    <el-dialog
        title="Chi tiết đơn xin nghỉ"
        :visible.sync="dialogVisible"
        width="650px"
        :before-close="closeDialogByButton"
        :close-on-click-modal="false"
        top="5vh"
    >
      <section v-loading="isLoading">
        <el-row :gutter="20">
          <el-col :span="24">

            <div class="shift-card">
              <div class="shift-header">
                <div class="student-profile">
                  <el-avatar :size="40" :src="absentLetterData.avatar" icon="el-icon-user-solid"
                             class="student-avatar"></el-avatar>
                  <div>
                    <strong class="student-name">{{ absentLetterData.nameStudent }}</strong>
                    <div class="class-name">Lớp: {{ absentLetterData.className }}</div>
                  </div>
                </div>
                <div class="status-cell">
                  <span :class="['status-badge', `status-badge--${(absentLetterData.status || '').toLowerCase()}`]">
                    {{ getStatus() }}
                  </span>
                </div>
              </div>

              <div class="meta-info-list">
                <div class="meta-row-item">
                  <span class="meta-label">Người làm đơn</span>
                  <span class="meta-value">
      :<i class="el-icon-user"></i>
      <strong>{{ absentLetterData.createdBy || 'Phụ huynh' }}</strong>
    </span>
                </div>

                <div class="meta-row-item">
                  <span class="meta-label">Ngày tạo đơn</span>
                  <span class="meta-value">
      :<i class="el-icon-date"></i>
      {{ absentLetterData.createdDate | formatDateTime }}
    </span>
                </div>

                <div class="meta-row-item">
                  <span class="meta-label">Tổng thời gian nghỉ</span>
                  <span class="meta-value">
      : Từ <strong class="text-highlight">{{ absentLetterData.fromDate | formatDate }}</strong>
      đến <strong class="text-highlight">{{ absentLetterData.toDate | formatDate }}</strong>
    </span>
                </div>

                <div class="meta-row-item">
                  <span class="meta-label">Số ngày nghỉ</span>
                  <span class="meta-value">
      : <span class="days-count-badge">{{ absentLetterData.totalDay || 0 }} ngày</span>
    </span>
                </div>

                <div class="meta-row-item">
                  <span class="meta-label">Lý do nghỉ</span>
                  <span class="meta-value text-reason">
      : <el-tag type="danger" size="mini" effect="plain" style="margin-right: 8px;">
        {{ getReasonType(absentLetterData.reasonType) }}
      </el-tag>
      {{ absentLetterData.reasonOther || '' }}
    </span>
                </div>
              </div>

              <div class="content-section">
                <div class="section-title-small">Nội dung:</div>
                <div class="note-blockquote">
                  {{ absentLetterData.content || 'Không có nội dung chi tiết' }}
                </div>
              </div>
            </div>

            <div class="shift-card">
              <div class="card-sub-title">
                <i class="el-icon-date"></i> Danh sách chi tiết các ngày nghỉ
              </div>

              <div class="permission-summary">
                <div class="summary-box approved">
                  <span class="num">{{
                      absentLetterData.approvedDates ? absentLetterData.approvedDates.length : 0
                    }}</span>
                  <span class="lbl">Ngày có phép</span>
                </div>
                <div class="summary-box unapproved">
                  <span class="num">{{
                      absentLetterData.unpermittedDates ? absentLetterData.unpermittedDates.length : 0
                    }}</span>
                  <span class="lbl">Ngày không phép</span>
                </div>
              </div>

              <div class="date-grid-container">
                <div
                    v-for="(item, index) in computedDateList"
                    :key="index"
                    class="date-grid-item"
                    :class="{ 'is-permitted': item.hasPermission }"
                >
                  <div class="grid-item-header">
                    <i :class="item.hasPermission ? 'el-icon-success' : 'el-icon-warning'"></i>
                    <span>{{ item.hasPermission ? 'Có phép' : 'Không phép' }}</span>
                  </div>
                  <div class="grid-item-body">
                    <span class="month-year">{{ item.date | formatDate }}</span>
                  </div>
                </div>

                <div v-if="computedDateList.length === 0" class="empty-grid">
                  Không có dữ liệu ngày nghỉ cụ thể.
                </div>
              </div>
            </div>

            <div class="shift-card" v-if="absentLetterData.attachments && absentLetterData.attachments.length > 0">
              <div class="card-sub-title"><i class="el-icon-picture-outline"></i> Ảnh đính kèm</div>
              <div class="image-preview-container">
                <el-image
                    v-for="(img, index) in attachments"
                    :key="index"
                    class="preview-img"
                    :src="img"
                    :preview-src-list="attachments"
                    fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>

            <div class="shift-card" v-if="absentLetterData.status !== 'PENDING'">
              <div class="card-sub-title"><i class="el-icon-user"></i> Thông tin phê duyệt</div>
              <div class="processor-box">
                <div class="processor-info">
                  <div class="avatar-placeholder">
                    {{ (absentLetterData.nameConfirm || 'QT').substring(0, 2).toUpperCase() }}
                  </div>
                  <div>
                    <h4 class="processor-name">{{ absentLetterData.nameConfirm || 'Hệ thống / Giáo viên' }}</h4>
                    <span class="processed-time">
                      <i class="el-icon-time"></i> Thời gian duyệt: {{ absentLetterData.confirmDate | formatDateTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </el-col>
        </el-row>
      </section>

      <span slot="footer" class="dialog-footer">
        <el-button
            v-if="absentLetterData.status === 'PENDING'"
            type="success"
            size="medium"
            :loading="isLoadingSave"
            @click.stop="handleApprove()"
        >
          <i class="el-icon-circle-check"/> Duyệt đơn
        </el-button>

        <el-button type="danger" size="medium" @click="closeDialogByButton">
          <i class="el-icon-circle-close"/> Đóng
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AbsentLetterV3Service from "@/absent_letter_v3/services/AbsentLetterV3Service";

export default {
  name: "AbsentLetterDetail",
  props: {
    dialogVisible: {type: Boolean, default: false, required: true},
  },
  data() {
    return {
      absentLetterData: {},
      attachments: [],
      isLoadingSave: false,
      isLoading: false,
      status: {
        "PENDING": "Đang chờ",
        "APPROVED": "Đã duyệt",
        "REJECTED": "Từ chối"
      },
      reasonTypes: {
        "HOSPITAL": "Khám / điều trị bệnh viện",
        "SICK": "Ốm bệnh",
        "FAMILY_REASON": "Việc gia đình",
        "VACATION": "Du lịch",
        "PERSONAL": "Lý do cá nhân",
        "WEATHER": "Thời tiết / thiên tai",
        "OTHER": "Lý do khác"
      }
    };
  },
  computed: {
    // Tự động gộp mảng approvedDates và unpermittedDates thành 1 danh sách đồng nhất để chạy Timeline
    computedDateList() {
      const list = [];
      if (this.absentLetterData.approvedDates) {
        this.absentLetterData.approvedDates.forEach(date => {
          list.push({date, hasPermission: true});
        });
      }
      if (this.absentLetterData.unpermittedDates) {
        this.absentLetterData.unpermittedDates.forEach(date => {
          list.push({date, hasPermission: false});
        });
      }
      // Sắp xếp ngày tăng dần
      return list.sort((a, b) => new Date(a.date) - new Date(b.date));
    }
  },
  methods: {
    async initialData(id) {
      this.isLoading = true;
      try {
        const res = await AbsentLetterV3Service.detail({id: id});
        this.absentLetterData = res.data.data;
        this.attachments = this.absentLetterData.attachments.map((attachment) => {
          return attachment.url
        });
      } catch (e) {
        this.$message.error('Lỗi lấy chi tiết đơn xin nghỉ');
      } finally {
        this.isLoading = false;
      }
    },
    getStatus() {
      return this.status[this.absentLetterData.status] || "Không xác định";
    },
    getReasonType(type) {
      return this.reasonTypes[type] || type || "Không xác định";
    },
    closeDialog() {
      this.absentLetterData = {};
      this.attachments = [];
      this.$emit("close");
    },
    closeDialogByButton() {
      this.closeDialog();
    },
    handleApprove() {
      this.$emit("approve", this.absentLetterData);
    },
  }
};
</script>

<style scoped lang="scss">
/* ================================================
   GIAO DIỆN KHUNG NỀN (CARDS)
   ================================================ */
.shift-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #eef2f6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  margin-bottom: 16px;
}

.shift-header {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.student-profile {
  display: flex;
  align-items: center;
  gap: 12px;

  .student-name {
    font-size: 18px;
    color: #1e3a8a;
  }

  .class-name {
    font-size: 13px;
    color: #64748b;
    margin-top: 2px;
  }
}

.card-sub-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Badge trạng thái viên thuốc */
.status-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;

  &--pending {
    background-color: #fef3c7;
    color: #d97706;
  }

  &--approved {
    background-color: #dcfce7;
    color: #15803d;
  }

  &--rejected {
    background-color: #fee2e2;
    color: #b91c1c;
  }
}

/* ================================================
   STYLE HIỂN THỊ HÀNG DỌC (VERTICAL LIST STYLE)
   ================================================ */
.meta-info-list {
  display: flex;
  flex-direction: column;
  gap: 12px; /* Khoảng cách giữa các dòng thông tin */
  margin-bottom: 20px;
  background-color: #fdfdfd;
  padding: 8px 0;

  .meta-row-item {
    display: flex;
    align-items: center; /* Căn giữa label và value trên cùng 1 dòng */
    border-bottom: 1px dashed #f1f5f9; /* Đường gạch nhẹ phân tách các dòng */
    padding-bottom: 10px;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    /* Định dạng phần tiêu đề (bên trái) */
    .meta-label {
      width: 240px; /* Cố định độ rộng label để phần nội dung bên phải thẳng hàng thẳng lối */
      min-width: 160px;
      font-size: 13px;
      color: #475569;
      font-weight: 700; /* In đậm toàn bộ tiêu đề */
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    /* Định dạng phần nội dung (bên phải) */
    .meta-value {
      font-size: 14px;
      color: #334155;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 6px;
      flex: 1;
    }

    /* Riêng phần lý do nghỉ nếu dài có thể cho tự xuống hàng linh hoạt */
    &.vertical-content {
      align-items: flex-start;
      flex-direction: column;
      gap: 6px;

      .meta-label {
        width: 100%;
      }

      .meta-value {
        padding-left: 4px;
      }
    }
  }
}

.days-count-badge {
  background-color: #ef4444;
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
}

.text-highlight {
  color: #2563eb;
  padding: 0 2px;
}

.text-reason {
  color: #1e293b;
  font-weight: 600;
}

.content-section {
  margin-top: 14px;

  .section-title-small {
    font-size: 14px;
    color: #64748b;
    margin-bottom: 6px;
  }
}

.note-blockquote {
  padding: 12px 16px;
  background-color: #f8fafc;
  border-left: 4px solid #3b82f6;
  border-radius: 0 8px 8px 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.6;
  word-break: keep-all;
}

/* ================================================
   STYLE MỚI: DANH SÁCH NGÀY NGHỈ DẠNG GRID Ô CỜ
   ================================================ */
.permission-summary {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;

  .summary-box {
    flex: 1;
    padding: 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 12px;

    &.approved {
      background-color: #f0fdf4;
      border: 1px solid #bbf7d0;

      .num {
        color: #166534;
      }
    }

    &.unapproved {
      background-color: #fff7ed;
      border: 1px solid #fed7aa;

      .num {
        color: #9a3412;
      }
    }

    .num {
      font-size: 18px;
      font-weight: 700;
    }

    .lbl {
      font-size: 13px;
      color: #475569;
    }
  }
}

/* Container bọc thẻ Grid */
.date-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); /* Tự động xuống dòng khi thiếu chỗ */
  gap: 12px;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px;
}

/* Thẻ ô vuông đại diện cho 1 ngày nghỉ */
.date-grid-item {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  /* Header nhỏ bên trên của thẻ */
  .grid-item-header {
    padding: 6px 8px;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
    border-bottom: 1px solid #e2e8f0;
  }

  /* Thân thẻ - Hiển thị ngày to rõ ràng */
  .grid-item-body {
    padding: 2px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;

    .day-num {
      font-size: 24px;
      font-weight: 700;
      line-height: 1;
      color: #1e293b;
    }

    .month-year {
      font-size: 12px;
      color: #64748b;
    }
  }

  /* Footer nhỏ dưới cùng của thẻ */
  .grid-item-footer {
    padding: 4px 8px;
    background: #f8fafc;
    font-size: 11px;
    color: #64748b;
    text-align: center;
    border-top: 1px dashed #e2e8f0;
  }

  /* Màu sắc chủ đạo khi CÓ PHÉP (Xanh lá) */
  &.is-permitted {
    border-color: #bbf7d0;

    .grid-item-header {
      background-color: #dcfce7;
      color: #15803d;
    }

    .grid-item-body {
      background-color: #f0fdf4;
    }
  }

  /* Màu sắc chủ đạo khi KHÔNG PHÉP (Cam đỏ) */
  &:not(.is-permitted) {
    border-color: #fed7aa;

    .grid-item-header {
      background-color: #ffedd5;
      color: #c2410c;
    }

    .grid-item-body {
      background-color: #fff7ed;
    }
  }
}

.empty-grid {
  grid-column: 1 / -1;
  padding: 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

/* ================================================
   IMAGE MINH CHỨNG
   ================================================ */
.image-preview-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  .preview-img {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    cursor: pointer;
  }
}

/* ================================================
   THÔNG TIN NGƯỜI XỬ LÝ & ĐỒNG BỘ
   ================================================ */
.processor-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px;

  .processor-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .avatar-placeholder {
      width: 36px;
      height: 36px;
      background: #3b82f6;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 13px;
    }

    .processor-name {
      margin: 0;
      font-size: 14px;
      color: #1e293b;
    }

    .processed-time {
      font-size: 12px;
      color: #64748b;
    }
  }

  .sync-status {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    padding-top: 10px;
    border-top: 1px dashed #e2e8f0;
    display: flex;
    align-items: center;
    gap: 6px;

    &.is-synced {
      color: #0d9488;
    }

    .text-muted-mini {
      font-size: 11px;
      color: #94a3b8;
    }
  }
}

/* ================================================
   STYLE ELEMENT DIALOG OVERRIDE
   ================================================ */
::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  padding: 18px 24px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 19px !important;
  font-weight: 600;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 22px;
}

::v-deep .el-dialog__body {
  max-height: 74vh;
  overflow-y: auto;
  background: #f8fafc;
  padding: 20px 24px !important;
}

::v-deep .el-dialog__footer {
  background: #f1f5f9;
  padding: 14px 24px !important;
  border-top: 1px solid #e2e8f0;
}
</style>